import {IOfferValue} from "@/store/slices/offerSlice";


export interface IPrecoAnual {
    ehPlanoAnual: boolean
    parcelas: number | null
    parcelaLabel: string
}

interface IPrecoAnualInput {
    oferta: IOfferValue
    priceLabel: string
}

export const formataMoeda = (valor: number): string =>
    `R$ ${valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`

export const maiorParcelamento = (zterm: unknown): number => {
    if (!Array.isArray(zterm)) {
        return 1
    }

    return zterm.reduce((maior: number, opcao) => {
        const parcelas = Number(String(opcao?.value ?? '').replace(/\D/g, ''))
        return parcelas > maior ? parcelas : maior
    }, 1)
}

const buildPrecoAnual = ({oferta, priceLabel}: IPrecoAnualInput): IPrecoAnual => {
    const periodicidade = oferta?.periodicidade ?? null
    const ehPlanoAnual = periodicidade
        ? periodicidade === 'anual' || periodicidade === 'anual_parcelada'
        : !!(oferta?.cd_oferta?.toLowerCase().startsWith('aa') || oferta?.valor?.periodo?.includes('ano'))

    if (!ehPlanoAnual) {
        return {ehPlanoAnual, parcelas: null, parcelaLabel: ''}
    }

    if (periodicidade === 'anual_parcelada') {
        return {ehPlanoAnual, parcelas: 12, parcelaLabel: priceLabel}
    }

    const parcelas = maiorParcelamento(oferta?.zterm)
    const valorNumerico = oferta?.valor?.valor
    if (parcelas > 1 && valorNumerico) {
        return {ehPlanoAnual, parcelas, parcelaLabel: formataMoeda(valorNumerico / parcelas)}
    }

    return {ehPlanoAnual, parcelas: null, parcelaLabel: ''}
}

export default buildPrecoAnual
